import { render } from "./JFCWrapper.vue?vue&type=template&id=56713bb4"
import script from "./JFCWrapper.vue?vue&type=script&lang=js"
export * from "./JFCWrapper.vue?vue&type=script&lang=js"

import "./JFCWrapper.vue?vue&type=style&index=0&id=56713bb4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/jobFitChecker/JFCWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56713bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56713bb4', __exports__)) {
    api.reload('56713bb4', __exports__)
  }
  
  module.hot.accept("./JFCWrapper.vue?vue&type=template&id=56713bb4", () => {
    api.rerender('56713bb4', render)
  })

}


export default __exports__